import { createFeatureSelector, createSelector } from '@ngrx/store';
import { historyFeatureKey, HistoryState } from './history.reducer';

export const selectHistoryFeature = createFeatureSelector<HistoryState>(historyFeatureKey);

export const selectActionsInHistory = createSelector(selectHistoryFeature, (state) => state.actions);
